import React from "react";
import './News.css';

const News =(props) =>{
    return(


        <section>
            <h4 className="text-center mt-4 text1" >News</h4>
            <div className=" Container">
                <div className="w-75  col1">
                    <div id="newshead">
                        <ul className="nav nav-tabs">
                            <li className="nav-item feliw">
                            <a className="nav-link active text-center" aria-current="page" href="More.com">Active</a>
                            </li>
                            <li className="nav-item feliw">
                            <a className="nav-link text-center" href="More.com">Link</a>
                            </li>
                            <li className="nav-item feliw">
                            <a className="nav-link text-center" href="More.com">Link</a>
                            </li>
                        </ul>
                    </div>
                    <div className="card mb-3 mt-3 p-1" >
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src="	https://mohit6795.github.io/Bikewale-Bootstrap/img/bmw-left-side-view0.webp" className="img-fluid rounded-start " alt="..."/>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">2022 BWW R 1250 RT launched in India at Rs 23.95 lakh</h5>
                                    <p className="card-text text-secondary">
                                        Deliveries of the bike have commenced this month for customers who have already booked it through the authorised dealerships. 
                                    </p>
                                    <p className="card-text"><small className="text-muted">Updated recently</small></p>
                                    <a href="More.com">Read more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3 p-1">
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/right-side-view1.webp" className="img-fluid rounded-start" alt="..."/>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Production-ready F77 electric motorcycle unveiled</h5>
                                    <p className="card-text text-secondary">
                                        Ultraviolette Automotive recently hosted an exclusive test ride of its electric motorcycle, the F77, with India’s pilot community.
                                    </p>
                                    <p className="card-text"><small className="text-muted">Last updated 1 mins ago</small></p>
                                    <a href="More.com">Read more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3 p-1" >
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src="https://mohit6795.github.io/Bikewale-Bootstrap/img/right-side-view0.webp" className="img-fluid rounded-start" alt="..."/>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">2022 Royal Enfield Interceptor 650 </h5>
                                    <p className="card-text text-secondary">
                                        Chinese two-wheeler manufacturer, Zontes Motorcycles, has been working on its upcoming three-cylinder engine. 
                                    </p>
                                    <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                                    <a href="More.com">Read more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default News;